import React from "react";
import img01 from "../../assets/img/images/about_img01.png";
import img02 from "../../assets/img/images/about_img02.png";
import { Link } from "react-router-dom";

const WhoWeAre = (props) => {
  return (
    <section id="about" className="about-area pt-130 pb-130">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="about-img wow fadeInLeft" data-wow-delay=".2s">
              <img src={img01} alt="" className="img-one" />
              <img src={img02} alt="" className="img-two" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-content wow fadeInRight" data-wow-delay=".2s">
              <div className="section-title mb-30">
                <span className="sub-title">QUEM NÓS SOMOS</span>
                <h2 className="title">
                  Sempre inovando em <span>tecnologia</span> transformando seus resultados.
                </h2>
              </div>
              <p>
              Especializados em soluções tecnológicas, estamos impulsionando há mais de 5 anos o sucesso de nossos clientes através da inovação digital e excelência em serviços. 
              Acreditamos que grandes transformações acontecem quando há confiança, parceria, profissionalismo e comprometimento.
              </p>
              <Link to="/" className="btn">
                Saiba mais
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
